import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { LineReveal, FadeUp } from "@/components/site/Reveal";
import { CONTACT } from "@/lib/content";

export const CtaBand = () => (
  <section data-testid="cta-band" className="relative bg-[var(--sun)] text-[var(--ink)] overflow-hidden">
    <div className="absolute -right-24 -top-24 w-96 h-96 rounded-full border-[40px] border-[var(--ink)]/10" aria-hidden />
    <div className="relative mx-auto max-w-[1440px] px-5 lg:px-10 py-24 lg:py-32 grid lg:grid-cols-12 gap-10 items-end">
      <div className="lg:col-span-8">
        <p className="font-mono text-xs tracking-[0.22em] uppercase mb-6">Coffee at your carwash — or a Zoom call</p>
        <LineReveal
          onView
          lines={["Let's have a clear,", "honest talk about", "your power bills."]}
          className="font-display font-black uppercase leading-[0.88] text-5xl sm:text-6xl lg:text-8xl"
        />
      </div>
      <FadeUp className="lg:col-span-4 flex flex-col gap-3">
        <Link to="/contact" data-testid="cta-band-quote-btn" className="group flex items-center justify-between rounded-full bg-[var(--ink)] text-white px-7 py-5 font-display font-bold uppercase tracking-wider text-lg transition-colors hover:bg-[var(--navy)]">
          Book a free assessment <ArrowRight className="transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
        <a href={CONTACT.hotlineHref} data-testid="cta-band-call-btn" className="flex items-center justify-between rounded-full border-2 border-[var(--ink)] px-7 py-5 font-display font-bold uppercase tracking-wider text-lg transition-colors hover:bg-[var(--ink)] hover:text-white">
          {CONTACT.hotline} <Phone size={20} />
        </a>
      </FadeUp>
    </div>
  </section>
);
